import { CommonModule } from '@angular/common'
import { Component, computed, DestroyRef, inject, input, output, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcButtonNTwoComponent } from 'src/app/shared/ddc/ddc-button-n-two/ddc-button-n-two.component'
import { CanvasArgs, CanvasCommand } from '../commands/canvas-command.model'

@Component({
  selector: 'ddc-command-invoker',
  templateUrl: './ddc-command-invoker.component.html',
  styleUrls: ['./ddc-command-invoker.component.scss'],
  imports: [CommonModule, AngularMaterialsModules, DdcButtonNTwoComponent],
  standalone: true,
})
export class DdcCommandInvokerComponent {
  private readonly destroyRef = inject(DestroyRef)

  command = input.required<CanvasCommand>()
  args = input.required<CanvasArgs>()
  executed = output<CanvasCommand>()

  private readonly running = signal(false)

  isEnabled = computed(() => this.command()?.canExecute(this.args()) ?? false)

  isSpinning = computed(() => (this.command()?.showSpinner(this.args()) ?? false) || this.running())

  tooltipText = computed(() => this.command()?.getTooltip(this.args()) ?? '')

  iconColor = computed(() => {
    if (!this.isEnabled()) return undefined
    return this.command()?.color
  })

  isButtonVariant = computed(() => this.command()?.variant === 'button')

  buttonSize = computed(() => this.command()?.size ?? 'small')

  onExecute(): void {
    if (!this.isEnabled()) return

    const cmd = this.command()
    this.running.set(true)

    cmd
      .execute(this.args())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.executed.emit(cmd),
        complete: () => this.running.set(false),
        error: () => this.running.set(false),
      })
  }
}
